export default {
  REQUEST: 'request-reset-password',
  VALIDATE: 'validate-token',
  PROCESS: 'process-reset-password',
};
